var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8067 3.52802C7.25664 3.52802 3.56812 7.21654 3.56812 11.7666C3.56812 16.3166 7.25664 20.0051 11.8067 20.0051C16.3567 20.0051 20.0452 16.3166 20.0452 11.7666C20.0452 7.21654 16.3567 3.52802 11.8067 3.52802ZM2.06812 11.7666C2.06812 6.38812 6.42822 2.02802 11.8067 2.02802C17.1851 2.02802 21.5452 6.38812 21.5452 11.7666C21.5452 17.145 17.1851 21.5051 11.8067 21.5051C6.42822 21.5051 2.06812 17.145 2.06812 11.7666Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5274 17.9555C17.8199 17.6622 18.2948 17.6616 18.588 17.9541L22.1121 21.469C22.4053 21.7615 22.4059 22.2363 22.1134 22.5296C21.8209 22.8229 21.3461 22.8235 21.0528 22.531L17.5287 19.0161C17.2355 18.7236 17.2349 18.2487 17.5274 17.9555Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1c64409c22d4d962b98506a01ec2b1f4.svg";
export { ForwardRef as ReactComponent };